import { put, call, takeEvery } from 'redux-saga/effects';
import { getErrorMessage, transvoiceLog } from 'utils/miscUtil';
import * as actions from './actions';

const delay = ms =>
  new Promise(res => {
    setTimeout(res, ms);
  });

export function* displayErrorOnTimer(payload) {
  try {
    const determinedError = payload ? getErrorMessage(payload) : null;
    yield put(actions.errorAddToStore({ errorMessage: determinedError }));
    yield delay(500);
    yield put(actions.errorRemoveFromStore({ errorMessage: determinedError }));
  } catch (e) {
    transvoiceLog('not able to determine the error message');
  }
}

export function* watchErrorReciver({ payload }) {
  yield call(displayErrorOnTimer, payload);
}
// eslint-disable-next-line func-names
export default function* () {
  yield takeEvery(actions.ERROR_RECEIVE, watchErrorReciver);
}
